import Dialog from "./Dialog";
import { DELETE_CONFIRMATION_TEXT } from "../../utils/constant";
import "./DeleteConfirmationModal.css";

const DeleteConfirmationModal = ({
  isOpen,
  type,
  name,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;
  const copy = DELETE_CONFIRMATION_TEXT[type];
  if (!copy) return null;

  return (
    <Dialog
      isModalOpen={isOpen}
      onToggleDialog={(isDialogOpen) => {
        if (!isDialogOpen) onCancel();
      }}
      mode="small-half"
      isCloseIconHidden={false}
    >
      <div className="delete-confirmation-modal__body">
        <h3 className="title delete-confirmation-modal__title">{copy.title}</h3>
        <p className="delete-confirmation-modal__message">{copy.message(name)}</p>
      </div>
      <div className="delete-confirmation-modal__actions">
        <button
          type="button"
          className="btn btn-viewPdf1 delete-confirmation-modal__confirm-btn"
          onClick={onConfirm}
        >
          Delete
        </button>
        <button
          type="button"
          className="btn btn-viewPdf1 delete-confirmation-modal__cancel-btn"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
